import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { FileKind } from "../../../define/FileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";
import openOreManager, { openOreBasicI } from "../../manager/openOreManager";
import { OpenOreDataSaveType, openOreEndInterface, OpenOreSpecialCollect, openOreStartInterface } from "./openOreConst";
import openOreExplain from "./openOreExplain";
import openOreGameObj from "./openOreGameObj";
import openOreOpen from "./openOreOpen";

const {ccclass, property} = cc._decorator;

@ccclass
export default class openOreGame extends cc.Component {

	@property({ type: cc.Node, displayName:'' })
	nodeCollect: cc.Node = null;

    @property({type:cc.Node,displayName:"center"})
    center:cc.Node = null;

    @property({type:cc.Prefab,displayName:"蚌壳预制体"})
    objPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"objLayout"})
    objLayout:cc.Node = null;

    @property({type:cc.Prefab,displayName:"开贝壳预制体"})
    cutPrefab:cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"描述界面"})
    explainPrefab:cc.Prefab = null;

    cutPage:cc.Node = null;

    oneVecAry:cc.Vec2[] = [cc.v2(-237,-352),cc.v2(0,-352),cc.v2(237,-352)];
    twoVecAry:cc.Vec2[] = [cc.v2(-237,-163),cc.v2(0,-163),cc.v2(237,-163)];
    threeVecAry:cc.Vec2[] = [cc.v2(-150,100),cc.v2(150,100)];

    openOreManager:openOreManager = null;

    objAry:{startObj:openOreStartInterface}[][] = [];

    vecAry:cc.Vec2[][] = [this.oneVecAry,this.twoVecAry,this.threeVecAry];

    eventPro:number = 0.1;

    private openOreSaveKey:string = OpenOreDataSaveType.OPEN_ORE_SAVE_KEY;

    private openOreDaySaveKey:string = OpenOreDataSaveType.OPEN_ORE_DAT_SAVE_KEY;

    onLoad(){
        this.openOreManager = NormalGameManager._instance.openOreManager;

        O1HD.on(MessageEventKind.EventName.REFRESH_NVWA_STORE_COLLECT, this.refreshCollect, this);
        O1HD.on(MessageEventKind.EventName.NVWA_STORE_COLLECT_ANI, this.CollectStoreAni, this);
    }

    loadSaveclamShell(){
        let g = O1HD.getServices().localStorageSrv.getStorage(this.openOreSaveKey);
        if(!g || g == ""){
            this.loadclamShellObjs().then();
            this.checkDayIsVaild();
        }else{
            if(this.checkDayIsVaild()){
                this.objAry = JSON.parse(g)
                this.loadSaveLayoutObj();
            }else{
                this.loadclamShellObjs().then();
            }
        }
    }

    checkDayIsVaild(){
        let isVaild = O1HD.getServices().localStorageSrv.getStorage(this.openOreDaySaveKey) == data_control.getCurrDateDayString();
        if(!isVaild){
            O1HD.getServices().localStorageSrv.setStorage(this.openOreDaySaveKey,data_control.getCurrDateDayString());
        }
        return isVaild;
    }

    start(){
        this.loadGamble().then();

        NormalGameManager._instance.taskDataManage.addNewTask(TaskKind.TaskId.TASK_4);

        this.refreshCollect();
    }
    
    async loadGamble(){
        this.loadSaveclamShell();
    }

    // 4 选 3
    // 3 选 3
    // 3 选 2
    // 2 选 2

    async loadclamShellObjs(){
        this.loadLayoutObj();
        // await this.loadOneLayoutObj();
        // await this.loadTwoLayoutObj();
        // await this.loadThreeLayoutObj();
        // await this.loadEndLayoutObj();
    }

    //出现过的素材id
    ariseMaterialIds:string[] = [];

    loadSaveLayoutObj(){
        let objAry:{startObj:openOreStartInterface}[][] = this.objAry;
        for(let i = 0;i<objAry.length;i++){
            let o = objAry[i];
            for(let j = 0;j<o.length;j++){
                let data = objAry[i][j];
                if(data){
                    let objNode:cc.Node = cc.instantiate(this.objPrefab);
                    let os = objNode.getComponent(openOreGameObj);
                    let isHaveBiao:boolean = true;
                    // if(i < 2){
                    //     isHaveBiao = false;
                    // }
                    os.bindDate(data.startObj,this,isHaveBiao);
                    let vec2 = this.vecAry[i][j];
                    objNode.setPosition(vec2);
                    objNode.setParent(this.objLayout);
                }
            }
        }
    }

    spliceOneSaveObj(obj:cc.Node){
        if(obj && obj.isValid){
            let os = obj.getComponent(openOreGameObj);
            let startData = os.startData;
            for(let i = 0;i<this.objAry.length;i++){
                let a = this.objAry[i];
                for(let j =0;j<a.length;j++){
                   let b = a[j];
                    if(JSON.stringify(b.startObj) == JSON.stringify(startData)){
                        a.splice(j,1);
                    }
                }
            }
        }
        this.writeOneSaveObj();
    }

    writeOneSaveObj(){
        O1HD.getServices().localStorageSrv.setStorage(this.openOreSaveKey,JSON.stringify(this.objAry));
    }

    async loadLayoutObj(){
        let createCountAry:number[] = [3,3,2];
        let priceRate = NormalGameManager._instance.getPriceRate();
        for(let i =0;i<createCountAry.length;i++){
            let objAry:openOreBasicI[] = this.openOreManager.openOreStartMap[i + 1];
            let createCount:number = createCountAry[i];
            let indexAry:number[] = [];
            this.objAry[i] = [];
            for(let j = 0;j<createCount;j++){
                let randIndex:number = Math.floor(Math.random()*objAry.length);
                while(indexAry.includes(randIndex)){
                    randIndex = Math.floor(Math.random()*objAry.length);
                }
                indexAry.push(randIndex);
                let obj = data_control.getRandItemOfArray(objAry[randIndex].infoArray);
                let objNode:cc.Node = cc.instantiate(this.objPrefab);
                let os = objNode.getComponent(openOreGameObj);
                let startObj:openOreStartInterface = {
                    id: obj.id,
                    icon: objAry[randIndex].icon,
                    gear: i + 1,
                    weight: obj.weight,
                    explain: obj.explain,
                    price: obj.price * priceRate,
                    bindBackId: obj.bindBackId,
                    stoneName: obj.stoneName,
                    incidents: obj.incidents,
                    onePosX: obj.onePosX,
                    onePosY: obj.onePosY,
                    twoPosY: obj.twoPosY,
                    twoPosX: obj.twoPosX,
                    priceRate: priceRate
                }
                let isHaveBiao:boolean = true;
                // if(i < 2){
                //     isHaveBiao = false;
                // }
                os.bindDate(startObj,this,isHaveBiao);
                this.objAry[i][j] = <{startObj:openOreStartInterface}>{};
                this.objAry[i][j].startObj = startObj;
                let vec2 = this.vecAry[i][j];
                objNode.setPosition(vec2);
                objNode.setParent(this.objLayout);
            }
        }
        this.writeOneSaveObj();
    }

    //开始锯某个木头
    startCutObj(obj:cc.Node){
        let cutNode:cc.Node = cc.instantiate(this.cutPrefab);
        let cs = cutNode.getComponent(openOreOpen);
        cs.bindNode(obj);
        cutNode.setParent(this.node);
    }

    startExplain(objNode:cc.Node){
        let explainPage:cc.Node = cc.instantiate(this.explainPrefab);
        let es = explainPage.getComponent(openOreExplain);
        es.bindData(objNode,this);
        explainPage.setParent(this.node);
    }

    refreshCollect() {
        let arr = OpenOreSpecialCollect;
        let gameData = NormalGameManager._instance.getGameData();
        let nvWaStore = gameData.nvWaStore
        let children = this.nodeCollect.children;
        for (let i = 0; i < arr.length; i++) {
            children[i].active = nvWaStore[i] ? true : false;
        }
    }

    CollectStoreAni(idx: number, pos: cc.Vec2) {
        let children = this.nodeCollect.children;
        let item = children[idx];
        let oScale = item.scale;
        let tPos = item.getPosition();
        let itemNode = cc.instantiate(item);
        itemNode.active = true;
        itemNode.scale = 1;
        itemNode.parent = this.nodeCollect;

        let sPos = this.nodeCollect.convertToNodeSpaceAR(pos);
        itemNode.setPosition(sPos);

        cc.tween(itemNode)
        .to(0.6, {x: tPos.x, y: tPos.y})
        .start();
        cc.tween(itemNode)
        .to(0.6, {scale: oScale})
        .call(()=> {
            item.active = true;
        })
        .removeSelf()
        .start();

    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.node.removeFromParent();
        this.node.destroy();
    }

    onBtnStock(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.objLayout.destroyAllChildren();
            this.objLayout.removeAllChildren();
            this.loadclamShellObjs();
        },()=>{

        },null,"开贝壳模式重新进货");
    }

    onClickCollect() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let count = 0;
        let gameData = NormalGameManager._instance.getGameData();
        gameData.nvWaStore.forEach((v)=> {
            if (v) {
                count++;
            }
        });

        if (count >= OpenOreSpecialCollect.length) {
            O1HD.getModules().uiControlModule.showLoading();
            utilsView.openPopupLayerTwo(
                FileKind.PrefabFilePath.OpenOreCollectLayer
                , null
                , null
                , null
                , null
                , false
            );
        } else {
            O1HD.getModules().uiControlModule.showMessageBox('似乎有什么神秘功能');
        }
    }

}